<template lang="pug">
footer
  .powered-by-controlla(@click="openUrl('http://controlla.com.mx/')")
    img(src="@/assets/poweredByControlla.svg")
</template>

<script>
export default {
  name: 'FooterControlla',
  methods: {
    openUrl (url) {
      window.open(url, '_blank')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
footer {
  background: rgba(var(--primary),1);
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
}
.powered-by-controlla {
  width: 180px;
  padding-top: 20px;
  cursor: pointer;
}
</style>
